import UserApi from "@/api/UserApi";
import { User } from "@/models";
import { AdministrationPayer_Request } from "@/models/APIModels/AdministrationPayer";
import AdministrationPayerViewModel, {
  CommitteeMemberAddressModel,
} from "@/models/ViewModels/AdministrationPayerViewModel";
import { UserViewModel } from "@/models/ViewModels/UserModel";
import { AdministrationPaymerTypeEnum } from "@/shared/ModelEnums";

export default class UserUsecase {
  private readonly _userApi: UserApi;
  constructor(userApi: UserApi = new UserApi()) {
    this._userApi = userApi;
  }

  async getUserByReference(userReference: string) {
    try {
      const result = await this._userApi.getAccountList(userReference);
      if (result.content) {
        result.content = this.mapUserToViewModel(result.content);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  private mapUserToViewModel(user: User): UserViewModel {
    return { ...user };
  }

  public convertUserToAdministratiorRequest(
    user: UserViewModel,
    administrationPayerTypeCd: AdministrationPaymerTypeEnum,
  ): AdministrationPayer_Request {
    let administrationPayer =
      user.administrationPayments.find(
        (ap) => ap.administrationPayerTypeCd === administrationPayerTypeCd,
      ) ?? new AdministrationPayerViewModel();

    if (administrationPayer.committeeMemberAddresses.length === 0)
      administrationPayer.committeeMemberAddresses.push(
        new CommitteeMemberAddressModel(),
      );

    return {
      userCategoryCd: user.userCategoryCd,
      userStatusCd: user.userStatusCd,
      userReference: user.userReference,
      givenName: user.givenName,
      familyName: user.familyName,
      emailAddress: user.emailAddress,
      mobilePhoneNumber: user.mobilePhoneNumber,
      otherPhoneNumber: user.otherPhoneNumber,
      password: user.password,
      isMobilePhoneNumberVerifiedInd: user.isMobilePhoneNumberVerifiedInd,
      isEmailAddressVerifiedInd: user.isEmailAddressVerifiedInd,
      userConcurrentlyRV: user.concurrencyRV,
      concurrencyRV: administrationPayer.concurrencyRV,
      administrationPayerTypeCd: administrationPayerTypeCd,
      paymentProviderAccountNum: administrationPayer.paymentProviderAccountNum,
      paymentProviderReference: administrationPayer.paymentProviderReference,
      currentPaymentSource: administrationPayer.currentPaymentSource,
      committeeMemberAddresses: administrationPayer.committeeMemberAddresses,
    };
  }
}
